import styled from 'styled-components'
import { CollectionItem as BaseCollectionItem } from '../Collection'

export const CollectionItem = styled(BaseCollectionItem)`
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 5px 5px 25px 5px;
  border-radius: 6px;
  border: 1px solid rgba(0, 0, 0, 0.3);
  background: #e5e5e5;
  overflow: hidden;
  height: 140px;

  &:hover > a {
    opacity: 1;
  }
`



// WEBPACK FOOTER //
// ./src/components/CollectionProducts/theme.js